<script>
import { eventGroupState } from "@app/store/eventGroupStore.svelte.js";
import { projectState } from "@app/store/projectStore.svelte.js";
import { insertHistoryAction } from "@app/store/historyStore.svelte.js";
import * as m from '@app/paraglide/messages.js';

function toggleWritingMode() {
    if (!eventGroupState[projectState.selected] || eventGroupState[projectState.selected].selected.length === 0) {
        return;
    }

    eventGroupState[projectState.selected].selected.forEach((evIndex) => {
        try {
            const event = eventGroupState[projectState.selected].events[evIndex];
            
            // Toggle between default and tbrl
            if (event.writingMode === 'tbrl') {
                event.writingMode = 'default';
            } else {
                event.writingMode = 'tbrl';
                // When switching to vertical, set position to top-left
                event.yPos = 'start';
                event.xPos = 'start';
            }
        } catch (err) {
            console.error("Writing mode toggle error");
            console.error(err.message);
            console.log(err);
        }
    });

    insertHistoryAction({
        name: "toggle writing mode",
        eventGroup: projectState.selected,
        snapshots: [
            {
                store: "eventGroupState",
                value: JSON.stringify(eventGroupState),
            },
        ],
    });
}

// Check if any selected events have vertical writing mode
let hasVerticalText = $derived(
    eventGroupState[projectState.selected]?.selected?.some((evIndex) =>
        eventGroupState[projectState.selected].events[evIndex]?.writingMode === 'tbrl'
    ) ?? false
);
let isDisabled = $derived(
    !eventGroupState[projectState.selected] ||
    eventGroupState[projectState.selected].selected.length === 0
);
</script>

<li class="nav-item" title={m.writing_mode_title()}>
    <a
        class="nav-link"
        href="#!/"
        role="button"
        id="writing-mode-btn"
        aria-label={m.writing_mode_aria_label()}
        class:disabled={isDisabled}
        aria-disabled={isDisabled}
        onclick={toggleWritingMode}>
        <i class="bi bi-sort-alpha-down" aria-hidden="true" style="transform: rotate({hasVerticalText ? '90deg' : '0deg'}); transition: transform 0.2s ease;"></i>
    </a>
</li>